import { Component, input, InputSignal } from '@angular/core';

@Component({
  selector: 'app-hour',
  standalone: true,
  imports: [],
  templateUrl: './hour.html',
  styleUrls: ['./hour.scss'],
})
export class Hour {
  public status: InputSignal<'past' | 'present' | 'future'> = input.required<'past' | 'present' | 'future'>();
}
